document.addEventListener('DOMContentLoaded', function () {
  const ASCII_PRINTABLE_REGEX = /^[\x20-\x7E]*$/;

  function getHiddenInput(input) {
    const hiddenInputId = input.dataset.hiddenInputId;
    return document.getElementById(hiddenInputId);
  }

  function getCounter(input) {
    const inputId = input.id.replace('custom-text-', '');
    return document.getElementById(`counter-${inputId}`);
  }

  function getError(input) {
    const inputId = input.id.replace('custom-text-', '');
    return document.getElementById(`error-${inputId}`);
  }

  function getMaxLength(input) {
    return parseInt(input.dataset.maxLength || input.getAttribute('maxlength') || '999', 10);
  }

  function getFieldLabel(input) {
    return input.dataset.propertyName || 'This field';
  }

  function normalizeValue(value) {
    return value.trim();
  }

  function updateCounter(input) {
    const counter = getCounter(input);
    if (!counter) return;

    const maxLength = getMaxLength(input);
    counter.textContent = `${input.value.length}/${maxLength}`;
  }

  function showError(input, message) {
    const errorEl = getError(input);
    input.classList.add('error');

    if (errorEl) {
      errorEl.textContent = message;
      errorEl.style.display = 'block';
    }
  }

  function clearError(input) {
    const errorEl = getError(input);
    input.classList.remove('error');

    if (errorEl) {
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    }
  }

  function syncHiddenInput(input, valueOverride = null) {
    const hiddenInput = getHiddenInput(input);
    if (!hiddenInput) return;

    hiddenInput.value = valueOverride !== null ? valueOverride : input.value;
  }

  function validateTextInput(input) {
    const normalized = normalizeValue(input.value);
    const maxLength = getMaxLength(input);
    const fieldLabel = getFieldLabel(input);

    clearError(input);

    if (normalized.length === 0) {
      return { valid: true };
    }

    if (normalized.length > maxLength) {
      showError(input, `${fieldLabel} must be ${maxLength} characters or fewer.`);
      return { valid: false };
    }

    if (!ASCII_PRINTABLE_REGEX.test(normalized)) {
      showError(
        input,
        `${fieldLabel} contains unsupported characters. Use standard keyboard characters only.`
      );
      return { valid: false };
    }

    return { valid: true };
  }

  function validateAllTextInputs(form) {
    const customTextInputs = form.querySelectorAll('.custom-text-field');
    let allValid = true;

    customTextInputs.forEach((input) => {
      const result = validateTextInput(input);
      if (!result.valid) {
        allValid = false;
      }
    });

    return allValid;
  }

  function handleCheckboxChange(checkbox) {
    const hiddenInputId = checkbox.dataset.hiddenInputId;
    const hiddenInput = document.getElementById(hiddenInputId);
    if (hiddenInput) {
      hiddenInput.value = checkbox.checked ? 'Yes' : 'No';
    }
  }

  function getSubmittedValue(input) {
    const normalized = normalizeValue(input.value);

    if (normalized.length === 0) {
      return 'None specified';
    }

    return normalized;
  }

  function handleTextInputChange(input) {
    updateCounter(input);

    const result = validateTextInput(input);

    if (result.valid) {
      clearError(input);
    }

    syncHiddenInput(input, getSubmittedValue(input));
  }

  function handleOptionInputChange(optionInputs) {
    optionInputs.forEach((input) => {
      const productFormInput = document.getElementById(
        `product-form-input-${input.dataset.optionName}-${input.dataset.blockId}`
      );
      if (!productFormInput) {
        return;
      }

      function updateFields(value) {
        productFormInput.value = value;
      }

      input.addEventListener('change', function () {
        updateFields(this.value);
      });

      if (input.checked || input.tagName === 'SELECT') {
        updateFields(input.value);
      }
    });
  }

  function initializeTextInputs() {
    const customTextInputs = document.querySelectorAll('.custom-text-field');

    customTextInputs.forEach((input) => {
      updateCounter(input);
      syncHiddenInput(input, getSubmittedValue(input));

      input.addEventListener('input', function () {
        handleTextInputChange(input);
      });

      input.addEventListener('blur', function () {
        validateTextInput(input);
      });
    });
  }

  function interceptProductFormSubmit() {
    const productForms = document.querySelectorAll('form[action*="/cart/add"]');

    productForms.forEach((form) => {
      form.addEventListener('submit', function (event) {
        const allValid = validateAllTextInputs(form);

        if (!allValid) {
          event.preventDefault();
          return;
        }

        const customTextInputs = form.querySelectorAll('.custom-text-field');
        customTextInputs.forEach((input) => {
          syncHiddenInput(input, getSubmittedValue(input));
        });
      });
    });
  }

  const customCheckboxes = document.querySelectorAll('.custom-checkbox-input');
  customCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', function () {
      handleCheckboxChange(checkbox);
    });
  });

  initializeTextInputs();

  const optionInputs = document.querySelectorAll(
    'input[name^="custom_option_"], select[name^="custom_option_"]'
  );
  if (optionInputs.length > 0) {
    handleOptionInputChange(optionInputs);
  }

  interceptProductFormSubmit();

  // [PickerRequired] Block add-to-cart until every dropdown (Logo 1-4) has a choice. Logo 3/4 can be "No logo".
  // Runs in the capture phase so it stops the theme's AJAX add-to-cart handler too.
  function validateRequiredPickers() {
    let firstBad = null;
    document.querySelectorAll('select[data-required="true"]').forEach(function (sel) {
      const err = document.getElementById('picker-error-' + sel.dataset.blockId);
      if (!sel.value) {
        const msg = sel.dataset.allowNone === 'true'
          ? 'Please choose a logo for ' + sel.dataset.label + ', or No logo.'
          : 'Please choose ' + (sel.dataset.label || 'an option') + '.';
        if (err) { err.textContent = msg; err.style.display = 'block'; }
        sel.classList.add('error');
        if (!firstBad) firstBad = sel;
      } else {
        if (err) { err.textContent = ''; err.style.display = 'none'; }
        sel.classList.remove('error');
      }
    });
    if (firstBad) {
      console.log('[PickerRequired] blocked add to cart: ' + firstBad.dataset.label + ' not chosen');
      firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' });
      firstBad.focus();
      return false;
    }
    return true;
  }

  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    if (!validateRequiredPickers()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  // Clear a dropdown's error as soon as the customer picks something in it.
  document.querySelectorAll('select[data-required="true"]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      const err = document.getElementById('picker-error-' + sel.dataset.blockId);
      if (sel.value && err) { err.textContent = ''; err.style.display = 'none'; sel.classList.remove('error'); }
    });
  });
});